jQuery(document).ready(function ($) {
    // hero-carousel
    setInterval(() => {
        $(".hero-carousel").each(function ( ) {
            $(this).find(".fixed-decoration").css("opacity", 0.3)
            var sizefactor = 0.3
            var targetWidth = $(this).find(".right:visible").width()*(1 + sizefactor)
            var targetOffset = $(this).find(".right:visible").width()*(sizefactor / 2)
            var targetLeft = $(this).find(".right:visible").offset().left
            var targetTop = $(this).find(".right:visible").offset().top
            $(this).find(".fixed-decoration").css("left", targetLeft - targetOffset)
            $(this).find(".fixed-decoration").css("top", targetTop - targetOffset)
            $(this).find(".fixed-decoration").css("width", targetWidth)
            var targetColor = $(this).find(".carousel-item:visible").attr('data-accent-color');
            $(this).find(".fixed-decoration").css("background-color", targetColor)
        })
    }, 1000/24);
    setTimeout(() => {
        $(".hero-carousel .fixed-decoration").css("transition", "0.6s")
    }, 600);
    // Nav Menu
    $("body").on("click",".dropdown-toggle", function () {
        if ($(this).hasClass("expanded")) {
            document.location.href = $(this).attr("data-url-on-expand") 
        } else {
            $(".dropdown-toggle").not(this).removeClass("expanded")
            $(this).addClass("expanded");
        }
    })



})